document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.tab-container').forEach(function (container) {

    const buttons = container.querySelectorAll('.tab-button');
    const panels = container.querySelectorAll('.tab-panel');
    const buttonsSlider = container.querySelector('.tab-buttons-slider');

    if (!buttons.length || !panels.length) return;


    // 初始化
    function activateTab(index) {

      buttons.forEach(function (button) {
        button.classList.remove('active');
      });

      panels.forEach(function (panel) {
        panel.classList.remove('active');
      });


      const activeButton = container.querySelector(
        `.tab-button[data-tab="${index}"]`
      );

      const activePanel = container.querySelector(
        `.tab-panel[data-tab="${index}"]`
      );


      if (activeButton) {
        activeButton.classList.add('active');
      }

      if (activePanel) {
        activePanel.classList.add('active');
      }

    }


    // 点击切换
    buttons.forEach(function (button) {

      button.addEventListener('click', function () {

        const tabIndex = this.getAttribute('data-tab');

        activateTab(tabIndex);


        // 移动端自动滚动到当前tab
        if (buttonsSlider) {

          const buttonRect = this.getBoundingClientRect();
          const sliderRect = buttonsSlider.getBoundingClientRect();


          const scrollPosition =
            buttonRect.left -
            sliderRect.left -
            (sliderRect.width / 2) +
            (buttonRect.width / 2);


          buttonsSlider.scrollBy({
            left: scrollPosition,
            behavior: 'smooth'
          });

        }


      });

    });


    // 默认第一个
    activateTab(
      buttons[0].getAttribute('data-tab')
    );


  });


});